import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    clear: 'c-grey-30 p-1 -mr-2',
    form: 'b rounded-full',
    input: 'b-0 h-9',
    submit: 'pl-3'
  },
  defaultSubmitPosition: 'start'
} satisfies RecursivePartial<VfConfig['searchBar']>
